import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useAuth } from '../context/AuthContext';

export default function Formulas() {
  const { user } = useAuth();
  const [formulas, setFormulas] = useState([]);
  const [materials, setMaterials] = useState([]);
  const [selected, setSelected] = useState(null);
  const [showForm, setShowForm] = useState(false);
  const [form, setForm] = useState({ code:'', name:'', density_per_100ml:95, items:[] });
  const [msg, setMsg] = useState({ text:'', ok:true });

  const load = () => axios.get('/api/formulas').then(r => setFormulas(r.data)).catch(()=>{});
  useEffect(() => {
    load();
    axios.get('/api/materials').then(r => setMaterials(r.data.filter(m=>m.category==='raw_material')));
  }, []);

  const selectFormula = async (f) => {
    const { data } = await axios.get(`/api/formulas/${f.id}`);
    setSelected(data); setShowForm(false);
  };

  const addItem = () => setForm(f=>({...f, items:[...f.items,{material_id:'',percentage:''}]}));
  const removeItem = (i) => setForm(f=>({...f, items:f.items.filter((_,idx)=>idx!==i)}));
  const updateItem = (i,k,v) => setForm(f=>({...f, items:f.items.map((it,idx)=>idx===i?{...it,[k]:v}:it)}));
  const totalPct = form.items.reduce((s,i)=>s+(parseFloat(i.percentage)||0),0);
  const showMsg = (text, ok=true) => { setMsg({text,ok}); setTimeout(()=>setMsg({text:'',ok:true}),3000); };

  const handleSubmit = async () => {
    try {
      if (form.id) await axios.put(`/api/formulas/${form.id}`, form);
      else await axios.post('/api/formulas', form);
      showMsg('บันทึกสูตรสำเร็จ');
      setShowForm(false); load();
    } catch (err) {
      showMsg(err.response?.data?.error || 'เกิดข้อผิดพลาด', false);
    }
  };

  return (
    <div>
      {msg.text && <div className={`alert ${msg.ok?'alert-success':'alert-danger'}`}>{msg.text}</div>}

      <div className="sh">สูตรน้ำหอมทั้งหมด</div>
      <div className="glass-card">
        <table className="tbl">
          <thead>
            <tr><th>รหัส</th><th>ชื่อกลิ่น</th><th>ความหนาแน่น</th>{user?.can_see_cost&&<th>ต้นทุน/kg</th>}<th>สถานะ</th><th></th></tr>
          </thead>
          <tbody>
            {formulas.map(f => (
              <tr key={f.id}>
                <td style={{ fontFamily:'monospace',fontSize:11,color:'var(--text-muted)' }}>{f.code}</td>
                <td style={{ fontWeight:600,color:'var(--text-primary)' }}>{f.name}</td>
                <td>{f.density_per_100ml} g/100ml</td>
                {user?.can_see_cost&&<td style={{ fontWeight:600 }}>฿{parseFloat(f.cost_per_kg||0).toFixed(2)}/kg</td>}
                <td><span className={`badge ${f.is_active?'badge-ok':'badge-warn'}`}>{f.is_active?'ใช้งาน':'ปิด'}</span></td>
                <td style={{ display:'flex',gap:6 }}>
                  <button className="btn-secondary" style={{ fontSize:11,padding:'4px 10px' }} onClick={() => selectFormula(f)}>ดูสูตร</button>
                  <button className="btn-secondary" style={{ fontSize:11,padding:'4px 10px' }} onClick={() => {
                    axios.get(`/api/formulas/${f.id}`).then(r => {
                      setForm({ ...r.data, items: r.data.items.map(i=>({material_id:i.material_id,percentage:i.percentage})) });
                      setShowForm(true); setSelected(null);
                    });
                  }}>แก้ไข</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        <div className="btn-row">
          <button className="btn-primary" onClick={() => {
            setShowForm(true); setSelected(null);
            setForm({ code:'', name:'', density_per_100ml:95, items:[{material_id:'',percentage:''}] });
          }}>+ สร้างสูตรใหม่</button>
        </div>
      </div>

      {/* Formula detail */}
      {selected && !showForm && (
        <>
          <div className="sh">รายละเอียดสูตร — {selected.name} ({selected.code})</div>
          <div className="glass-card">
            {user?.can_see_cost && (
              <div style={{ display:'flex',gap:20,marginBottom:14,flexWrap:'wrap' }}>
                <div><div className="fl" style={{ marginBottom:2 }}>ต้นทุน/kg</div><div style={{ fontSize:18,fontWeight:700,color:'var(--accent)' }}>฿{parseFloat(selected.cost_per_kg||0).toFixed(2)}</div></div>
                <div><div className="fl" style={{ marginBottom:2 }}>ต้นทุน/30ml</div><div style={{ fontSize:18,fontWeight:700,color:'var(--accent)' }}>฿{(parseFloat(selected.cost_per_kg||0)*selected.density_per_100ml/100*30/1000).toFixed(2)}</div></div>
              </div>
            )}
            <table className="tbl">
              <thead><tr><th>วัตถุดิบ</th><th>%</th>{user?.can_see_cost&&<><th>avg cost</th><th>ต้นทุน/kg</th></>}</tr></thead>
              <tbody>
                {selected.items?.map(item => (
                  <tr key={item.id}>
                    <td style={{ fontWeight:500,color:'var(--text-primary)' }}>{item.material_name} <span style={{ fontSize:10,color:'var(--text-muted)' }}>({item.unit})</span></td>
                    <td style={{ fontWeight:700,color:'var(--accent)' }}>{item.percentage}%</td>
                    {user?.can_see_cost&&<td>฿{parseFloat(item.avg_cost||0).toFixed(4)}</td>}
                    {user?.can_see_cost&&<td>฿{parseFloat(item.cost_contribution||0).toFixed(4)}</td>}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </>
      )}

      {/* Create/Edit form */}
      {showForm && (
        <>
          <div className="sh">{form.id ? 'แก้ไขสูตร' : 'สร้างสูตรใหม่'}</div>
          <div className="glass-card">
            <div className="grid-2">
              <div className="form-group"><label className="fl">รหัสสูตร</label><input className="fi" value={form.code} onChange={e => setForm(f=>({...f,code:e.target.value}))} placeholder="F-001" disabled={!!form.id}/></div>
              <div className="form-group"><label className="fl">ชื่อกลิ่น</label><input className="fi" value={form.name} onChange={e => setForm(f=>({...f,name:e.target.value}))} placeholder="Rose Royale"/></div>
              <div className="form-group"><label className="fl">ความหนาแน่น (g/100ml)</label><input className="fi" type="number" value={form.density_per_100ml} onChange={e => setForm(f=>({...f,density_per_100ml:e.target.value}))}/></div>
            </div>
            <div className="divider"/>
            <div style={{ display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:8 }}>
              <div className="fl">ส่วนผสม</div>
              <span style={{ fontSize:11,fontWeight:600,color:Math.abs(totalPct-100)<0.01?'var(--success)':'var(--warning)' }}>
                รวม: {totalPct.toFixed(2)}% {Math.abs(totalPct-100)<0.01?'✓':'⚠'}
              </span>
            </div>
            {form.items.map((item,i) => (
              <div key={i} style={{ display:'grid',gridTemplateColumns:'3fr 80px auto',gap:6,marginBottom:6,alignItems:'center' }}>
                <select className="fi" value={item.material_id} onChange={e => updateItem(i,'material_id',e.target.value)}>
                  <option value="">เลือกวัตถุดิบ</option>
                  {materials.map(m=><option key={m.id} value={m.id}>{m.name}</option>)}
                </select>
                <input className="fi" type="number" placeholder="%" value={item.percentage} onChange={e => updateItem(i,'percentage',e.target.value)}/>
                <button className="btn-secondary" style={{ padding:'7px 10px' }} onClick={() => removeItem(i)}>✕</button>
              </div>
            ))}
            <button className="btn-secondary" style={{ fontSize:11,padding:'5px 12px',marginBottom:10 }} onClick={addItem}>+ เพิ่มส่วนผสม</button>
            <div className="btn-row">
              <button className="btn-secondary" onClick={() => setShowForm(false)}>ยกเลิก</button>
              <button className="btn-primary" onClick={handleSubmit}>บันทึกสูตร</button>
            </div>
          </div>
        </>
      )}
    </div>
  );
}
